import { SliceProps } from "@/Slice/index"
import { EmbedContentBase } from "@jog/react-components"

export const EmbedContent = ({ slice: { primary, items }, className }: SliceProps<"embed_content">) => (
    <div className={className}>
        <EmbedContentBase items={items} height={primary.height} />
    </div>
)
